import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';

export default function Sidebar() {
    const [subMenu, setSubMenu] = useState(false);
    const userAuth = JSON.parse(sessionStorage.getItem('user'));
    const [showMenu, setShowMenu] = useState(true);
    const config = userAuth.type === 1;
    const billet = !config;
    const [width, setWidth] = useState(window.innerWidth);
    window.addEventListener('resize', () => {
        setWidth(window.innerWidth);
    });

    useEffect(() => {
        width < 640 ? setShowMenu(false) : setShowMenu(true);
    }, [width]);

    return (
        <aside>
            <button className="m-auto mt-16 z-50 fixed flex px-1 float-left z-50 sm:hidden "
                    onClick={() => setShowMenu(!showMenu)}>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24"
                     stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16"/>
                </svg>
            </button>

            {showMenu && <div
                className='bg-gray-200 sm:bg-inherit mt-16 border-r-2 z-40 fixed flex w-52 h-full px-1 float-left'>
                <ul className="mb-5 mt-5 text-lg text-gray-700">
                    <li>
                        <Link to="/"
                              className="flex items-center py-4 px-6 h-12 overflow-hidden rounded hover:text-gray-900 hover:bg-gray-100 transition duration-300 ease-in-out"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24"
                                 stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                      d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"/>
                            </svg>
                            <span className="pl-3">Home</span>
                        </Link>
                    </li>
                    {config && (
                        <li onMouseEnter={() => {
                            setSubMenu(true)
                        }} onMouseLeave={() => {
                            setSubMenu(false)
                        }}>
                            <Link to="/"
                                  className="flex items-center py-4 px-6 h-12 overflow-hidden rounded hover:text-gray-900 hover:bg-gray-100 transition duration-300 ease-in-out"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none"
                                     viewBox="0 0 24 24"
                                     stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                          d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"/>
                                </svg>

                                <span className="pl-3">Configurações</span>
                            </Link>
                            {subMenuConfig(config, subMenu)}
                        </li>
                    )}
                    {billet && (
                        <li>
                            <Link to="/billets"
                                  className="flex items-center py-4 px-6 h-12 overflow-hidden rounded hover:text-gray-900 hover:bg-gray-100 transition duration-300 ease-in-out"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none"
                                     viewBox="0 0 24 24"
                                     stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                          d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"/>
                                </svg>
                                <span className="pl-3"> Boletos</span>
                            </Link>
                        </li>
                    )}
                </ul>
            </div>}
        </aside>
    );
}

const subMenuConfig = (config, subMenu) => {
    return (
        <ul className={`mb-5  ${subMenu ? '' : 'hidden'}`}>
            {config && (<li>
                <Link to="/users"
                      className="ml-5 flex items-center text-sm py-4 px-6 h-12 overflow-hidden text-gray-700 text-ellipsis whitespace-nowrap rounded hover:text-gray-900 hover:bg-gray-100 transition duration-300 ease-in-out"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24"
                         stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                              d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
                    </svg>
                    <span className="pl-3">Usuario</span>
                </Link>
            </li>)}
        </ul>
    )
}

